import { legislativeTypeStatusValueLabels } from './value-labels.js';
/** Classification of legislative item types used by the agency (e.g. Ordinance, Resolution, Motion). */
export const legislativeTypesCube = {
    category: 'Legislation',
    description: 'Legislative item type definitions with reading requirements and status.',
    label: 'Legislative Item Types',
    requiredModule: 'hasAgenda',
    measures: {
        'legislative_types.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'legislative_types.name': { label: 'Name', type: 'string' },
        'legislative_types.code': { label: 'Code', type: 'string' },
        'legislative_types.status': {
            label: 'Status',
            type: 'string',
            valueLabels: legislativeTypeStatusValueLabels,
        },
    },
    timeDimensions: {
        'legislative_types.created_at': { label: 'Created At', type: 'date' },
        'legislative_types.updated_at': { label: 'Updated At', type: 'date' },
    },
};
